import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ['fieldWorkflowId' ]
    connect() {
        console.log('connected with stimulus')
    }
}
